import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import FunctionalCalendar from 'vue-functional-calendar'
import VueScrollTo from 'vue-scrollto'
import qs from 'qs'
import _ from 'lodash'
import { formatDate, getTodaysDate, formatCalendarDate } from '../registration-form/date-helpers'
import Toast from '../toast'
import { checkEmail } from '../check-email'
import { ModelListSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

const updateFormEl = document.getElementById('v-companion-animal-update-form')

function beforeUnload(e) {
  e.preventDefault()
  e.returnValue = ''
}

// Date picker defaults:
Vue.use(FunctionalCalendar)

// Animate page scroll:
Vue.use(VueScrollTo)

Vue.use(VueAxios, axios)

let path
if (updateFormEl) {
  path = updateFormEl.dataset.action
  path = path.substr(path.length - 1) === '/' ? path : path + '/'
}

export default Vue.component('update-companion-animal-form', {
  components: {
    ModelListSelect,
  },
  data() {
    const originalData = {
      FormToken: updateFormEl.dataset && updateFormEl.dataset.token,
      confirmPermission: false,
      newMicrochipData: [],
    }
    Object.assign(originalData, window.CANZ?.companionAnimalDetails || {})
    Object.assign(originalData, window.CANZ?.contactDetails || {})
    const fields = JSON.parse(JSON.stringify(originalData))
    return {
      currentTab: window.location.hash?.substr(1) === 'contact' ? 'contact' : 'profile',
      implantMonth: '',
      implantYear: '',
      isFull: true,
      isNewRego: false,
      showAddressDetails: false,
      guardianAccountStatus: originalData.guardianEmail ? 'unchanged' : 'unknown',
      isGuardian: updateFormEl?.dataset?.isGuardian === 'true',
      loading: false,
      fields: {
        ...fields
      }, // Make a clone including microchips array
      breeds: window.CANZBreeds?.[originalData?.speciesId] || [],
      equidSpeciesIds: window.CANZEquidFormExtensionSpeciesIds,
      organisations: window.CANZOrganisations,
      vetClinics: window.CANZVetClinics,
      countries: window.CANZCountries,
      formErrors: [],
      errors: {},
      originalData,
      allChangesSaved: false,
      anyChanges: false,
      editCurrentMicrochips: false,
      beforeUnload,
      dateBornDateObject: {
        currentDate: '',
        selectedDate: originalData.dateBorn ?? '',
        selectedDateTime: false,
        selectedHour: '00',
        selectedMinute: '00',
        selectedDatesItem: '',
        selectedDates: [],
        dateRange: {
          start: '',
          end: ''
        },
        multipleDateRange: [],
        isTypeable: true
      }, // Add each new DateObject to `watch` to ensure unsaved changes on beforeUnload on these fields trigger the browser alert.
      importedDateObject: {
        currentDate: '',
        selectedDate: originalData.importDate ?? '',
        selectedDateTime: false,
        selectedHour: '00',
        selectedMinute: '00',
        selectedDatesItem: '',
        selectedDates: [],
        dateRange: {
          start: '',
          end: '',
        },
        multipleDateRange: [],
      },
      exportedDateObject: {
        currentDate: '',
        selectedDate: originalData.exportDate ?? '',
        selectedDateTime: false,
        selectedHour: '00',
        selectedMinute: '00',
        selectedDatesItem: '',
        selectedDates: [],
        dateRange: {
          start: '',
          end: '',
        },
        multipleDateRange: [],
      },
    }
  },
  created: function () {
    this.debouncedCheckEmail = _.debounce(this.checkEmail, 500)
    this.debouncedCheckChanges = _.debounce(this.checkChanges, 400)
  },
  watch: {
    fields: {
      handler: function () {
        this.debouncedCheckChanges()
      },
      deep: true,
    },
    dateBornDateObject: {
      handler: function () {
        this.debouncedCheckChanges()
      },
      deep: true,
    },
    importedDateObject: {
      handler: function () {
        this.debouncedCheckChanges()
      },
      deep: true,
    },
    exportedDateObject: {
      handler: function () {
        this.debouncedCheckChanges()
      },
      deep: true,
    },
  },
  computed: {
    totalMicrochips() {
      return this.fields.microchips.length + this.fields.newMicrochipData.length < 3
    },
    isEquidSpecies () {
      return this.equidSpeciesIds.find(id => id == this.fields.speciesId)
    },
  },
  methods: {
    speciesChanged() {
      this.breeds = window.CANZBreeds?.[this.fields.speciesId] || []
    },
    catchErrors(error) {
      this.loading = false
      const errors = {}
      let firstErrorKey = null
      const addressFields = ['StreetNumber', 'Street', 'Suburb', 'Region', 'PostalCode']
      Object.keys(error?.response?.data?.errors || {}).forEach((k) => {
        if (typeof this.fields[k] !== 'undefined') {
          if (!firstErrorKey) {
            firstErrorKey = k
          }
          if (addressFields.includes(k)) {
            this.showAddressDetails = true
          }
          errors[k] = error.response.data.errors[k]
        } else {
          this.formErrors.push(error.response.data.errors[k])
        }
      })
      this.errors = errors
      // Once errors displayed, scroll window to first instance within current step
      this.$nextTick(() => {
        let errorElement = document.getElementById(firstErrorKey)
        if (!errorElement) {
          errorElement = document.getElementsByClassName('c-message--error')?.[0]
        }
        if (errorElement) {
          VueScrollTo.scrollTo(errorElement, 400, {
            offset: -75,
          })
        }
      })
    },
    getTodaysDate,
    addMicroChip() {
      this.fields.newMicrochipData.push({
        id: null,
        number: '',
        confirm: '',
        implanterName: '',
        dateImplanted: '',
        implantedDateObject: {
          currentDate: '',
          selectedDate: getTodaysDate(),
          selectedDateTime: false,
          selectedHour: '00',
          selectedMinute: '00',
          selectedDatesItem: '',
          selectedDates: [],
          dateRange: {
            start: '',
            end: '',
          },
          multipleDateRange: [],
        },
        clinicId: (updateFormEl.dataset && updateFormEl.dataset.clinic) || '',
      })
    },
    removeMicroChip() {
      this.fields.newMicrochipData.pop()
    },
    saveChanges(e) {
      e.preventDefault()

      // Convert date format
      this.fields.dateBorn = formatCalendarDate(this.dateBornDateObject.selectedDate)
      this.fields.importDate = formatCalendarDate(this.importedDateObject.selectedDate)
      this.fields.exportDate = formatCalendarDate(this.exportedDateObject.selectedDate)
      this.fields.newMicrochipData.forEach((microchipData) => {
        if (microchipData.implantedDateObject) {
          microchipData.dateImplanted = formatCalendarDate(microchipData.implantedDateObject.selectedDate)
        }
      })

      this.formErrors = []
      this.errors = {}
      this.loading = true

      this.axios({
        method: 'POST',
        url: path,
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
          ...this.fields,
          tab: this.currentTab,
        }),
        maxRedirects: 0,
      })
        .then((response) => {
          window.removeEventListener('beforeunload', beforeUnload)
          window.location = this.isGuardian
            ? '/my-companion-animals/'
            : '/implanter/dashboard?s=' + this.fields?.microchips?.[0]?.number
        })
        .catch((error) => {
          this.catchErrors(error)
          this.$toast.error({
            component: Toast,
            props: {
              heading: 'Changes not saved',
              body: 'Please review validation errors and try again.',
            },
          })
        })
    },
    checkEmail,
    checkChanges() {
      this.anyChanges = Object.keys(this.originalData).some((k) => {
        if (k === 'microchips') {
          return JSON.stringify(this.fields[k]) !== JSON.stringify(this.originalData[k])
        }
        if (k === 'dateBorn') {
          return JSON.stringify(this.dateBornDateObject.selectedDate) !== JSON.stringify(this.originalData[k])
        }
        if (k === 'importDate') {
          return JSON.stringify(this.importedDateObject.selectedDate) !== JSON.stringify(this.originalData[k])
        }
        if (k === 'exportDate') {
          return JSON.stringify(this.exportedDateObject.selectedDate) !== JSON.stringify(this.originalData[k])
        }
        if (this.originalData[k] === null) {
          return this.fields[k] !== null
        }
        if (typeof this.originalData[k] === 'undefined') {
          return typeof this.fields[k] !== 'undefined'
        }
        return this.originalData[k].toString() !== this.fields[k].toString()
      })
      if (this.anyChanges) {
        window.addEventListener('beforeunload', beforeUnload)
        this.allChangesSaved = false
      } else {
        window.removeEventListener('beforeunload', beforeUnload)
      }
    },

    toggleEditingMicrochips() {
      if (this.editCurrentMicrochips) {
        this.fields.microchips = JSON.parse(JSON.stringify(this.originalData.microchips))
      }
      this.editCurrentMicrochips = !this.editCurrentMicrochips
    },
    changeTab(tab) {
      this.currentTab = tab === 'contact' ? 'contact' : 'profile'
      window.location.hash = this.currentTab
    },
    viewCertificate(id) {
      const urlPrefix = this.isGuardian ? 'my-companion-animals/' : 'implanter/dashboard/'
      const certificateUrl = `${urlPrefix}registration-details/${id}`

      window.open(certificateUrl, '_blank')
    },
  },
})
